import { render, staticRenderFns } from "./news-digest.vue?vue&type=template&id=4369c195&scoped=true"
import script from "./news-digest.vue?vue&type=script&lang=js"
export * from "./news-digest.vue?vue&type=script&lang=js"
import style0 from "./news-digest.vue?vue&type=style&index=0&id=4369c195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369c195",
  null
  
)

export default component.exports